import { FC, useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import {
  IconButton,
  Notification,
  Popover,
  toaster,
  Whisper,
} from 'rsuite'
import TrashIcon from '@rsuite/icons/Trash'
import dynamic from 'next/dynamic'

import useBuyerCatalogs from '../../../services/useBuyerCatalogs'
import AddNewEntryButton from '../Account/AddNewEntryButton'
import EditIcon from '../../Icons/SavedProducts/EditIcon'

import styles from '../../../styles/BuyerPortal/ModifyCatalogButton.module.less'

const CatalogModal = dynamic(() => import('./CatalogModal'))

interface ModifyCatalogButtonProps {
  action?: 'create' | 'rename' | 'delete'
  catalogName?: string
  isLoading?: boolean
}

const ModifyCatalogButton: FC<ModifyCatalogButtonProps> = (props) => {
  const {
    action = 'create',
    catalogName = null,
    isLoading = false,
  } = props

  const [isCatalogModalOpen, setIsCatalogModalOpen] = useState(false)

  const { t } = useTranslation('buyerProfile')
  const { errorMessage } = useBuyerCatalogs()

  useEffect(() => {
    if (errorMessage) {
      toaster.push(
        <Notification
          type="error"
          header={<b>{t('auth:Error')}</b>}
          closable
        >
          {t(errorMessage)}
        </Notification>,
        {
          placement: 'bottomCenter',
        },
      )
    }
  }, [errorMessage])

  return (
    <>
      {action === 'create' && (
        <AddNewEntryButton
          testId="catalog-add-new-catalog-button"
          buttonText={t('Create new catalog')}
          openModal={() => {
            setIsCatalogModalOpen(true)
          }}
          isLoading={isLoading}
        />
      )}
      {action === 'rename' && (
        <Whisper
          trigger="hover"
          placement="bottom"
          speaker={<Popover className={styles['remove-popover']}>{t('Rename catalog')}</Popover>}
        >
          <IconButton
            data-testid="rename-catalog-button"
            className={`${styles['icon-button']} ${styles['height-fix']}`}
            icon={<EditIcon />}
            disabled={isLoading}
            onClick={() => setIsCatalogModalOpen(true)}
          />
        </Whisper>
      )}
      {action === 'delete' && (
        <Whisper
          trigger="hover"
          placement="bottom"
          speaker={<Popover className={styles['remove-popover']}>{t('Delete catalog')}</Popover>}
        >
          <IconButton
            data-testid="delete-catalog-button"
            className={styles['icon-button']}
            icon={<TrashIcon />}
            disabled={isLoading}
            onClick={() => setIsCatalogModalOpen(true)}
          />
        </Whisper>
      )}

      {isCatalogModalOpen && (
        <CatalogModal
          action={action}
          catalogName={catalogName}
          setIsCatalogModalOpen={setIsCatalogModalOpen}
        />
      )}
    </>
  )
}

export default ModifyCatalogButton
